module.exports = __webpack_public_path__ + "img/DSC04093.9418aa74.jpg";